import { hex2Rgb } from './core/parse-css-color/utils/hex-rgb.es.js';

function getRgbaFromHex(hex, alpha = 1) {
  var _a;
  const rgb = hex2Rgb(hex);
  if (!rgb) {
    return null;
  }
  return `rgba(${rgb.red},${rgb.green},${rgb.blue},${(_a = rgb == null ? void 0 : rgb.alpha) != null ? _a : alpha})`;
}

export { getRgbaFromHex };
